import { CanvasInfo, Camera, matUtils } from "../base";
import * as THREE from 'three';


/**
 * class: wcItemUtils
 */
 export class wcItemUtils {
    public static getUrl(obj: any): string {
        if (obj == undefined) return "";
        if (obj.url != undefined) return obj.url;
        return wcItemUtils.getUrl(obj.parent);
    }

    // public static extractPart(obj: THREE.Object3D): THREE.Group {
    //     if (obj == undefined) return undefined;
    //     const mobj = <THREE.Group>(obj);
    //     if ((mobj.userData.attribute && mobj.userData.attribute.objectId != undefined) && mobj.userData.attribute.objectId.match(/(^equ.*)|(^fit.*)|(^fur.*)|(^dec.*)/)) return mobj;
    //     return wcItemUtils.extractPart(obj.parent);
    // }

    public static getObjectId(obj: THREE.Object3D): string {
        const object = <THREE.Object3D>(obj);
        if (object == undefined) return "";
        if (object.userData.attribute && object.userData.attribute.objectId != undefined) {
            return object.userData.attribute.objectId;
        }
        return wcItemUtils.getObjectId(obj.parent);
    }
}

export class attribute {
    public layer: string;
    public alternative: any[];

    public colladaId: string;
    public objectId: string;
    public objectName: string;
    public originalUp: string; // unused
    public original_name: string;
    public thumbnail: string;           // modelinfo あり
    public type: string;        // -
    public reverse: boolean;
    public url: string
}
